<template>
  <div class="my-form">
    <Form :model="formData" :label-width="100">
    <Row>
        <Col span="10">
          <div class="form-title">基础信息</div>
          <FormItem label="姓名">
            <Input v-model="formData.DealerInfo.Name" style="width:500px" placeholder=""></Input>
          </FormItem>
          <FormItem label="电话(手机)">
            <Input v-model="formData.DealerInfo.Tel" style="width:500px" placeholder=""></Input>
          </FormItem>
          <FormItem label="密码">
            <Input v-model="formData.DealerInfo.Password" style="width:500px" placeholder=""></Input>
          </FormItem>
          <FormItem label="固定电话">
            <Input v-model="formData.DealerInfo.ContactTel" style="width:500px" placeholder=""></Input>
          </FormItem>
          <FormItem label="维护专员">
            <Input v-model="formData.DealerInfo.Broker" style="width:500px" placeholder=""></Input>
          </FormItem>
        </Col>
        <Col span="14">
          <div class="form-title">门店信息</div>
          <FormItem label="店名">
            <Input v-model="formData.DealerInfo.DealerName" style="width:500px" placeholder=""></Input>
          </FormItem>

          <FormItem label="门店电话">
            <Input v-model="formData.DealerStore.StoreTel" style="width:500px" placeholder=""></Input>
          </FormItem>
          <FormItem label="门店类型">
                <Select v-model="formData.DealerStore.StoreType" style="width:200px">
                  <Option :value="1" >专卖店</Option>
                  <Option :value="2" >授权店</Option>
                  <Option :value="3" >在建店</Option>
                </Select>
          </FormItem>
          <FormItem label="门店标签">
              <Input @on-search="addTag"  search enter-button="添加" placeholder="输入一个标签名" />              
              <Tag :key="idx"  :name="idx" size="large" closable  @on-close="removeTag" v-for="(item,idx) in splitedList(formData.DealerStore.StoreTag)">
                {{item}}</Tag>              
          </FormItem>
          <FormItem label="营业时间">
            <Input v-model="formData.DealerStore.OpenTime" style="width:500px" placeholder="9:00"></Input>
            <br>
            <Input v-model="formData.DealerStore.CloseTime" style="width:500px" placeholder="18:00"></Input>
          </FormItem>

          <FormItem label="门头照片">
            <div class="img-list">
              <div v-for="(item, index) in formData.DealerStoreImgs"
                v-if="item.ImgType==1"
               :key="index" class="img-cell"
                v-bind:style="{'background-image':'url(' + item.ImgUrl+ ')','background-size': 'cover','background-position': 'center center','background-repeat':'no-repeat','background-color': 'black'}">
                <div class="demo-upload-list-cover">
                  <Icon type="ios-eye-outline" size="30" @click.native="viewimg(item)"></Icon>
                  <Icon type="ios-trash-outline" size="30" @click.native="handleRemove(index)"></Icon>
                </div>
              </div>
            </div>
            <Upload type="drag" :format="['jpg']" :max-size="2048" 
              :with-credentials="true" :show-upload-list="true"
              :on-success="UploadSuccess" :on-error="UploadError" :on-format-error="handleFormatError"
              :on-exceeded-size="handleMaxSize" :before-upload="handleBeforeUpload" :action="StoreHeadImg_uploadUrl"
              style="display: inline-block;min-width:600px;" >
              <div style="padding: 20px 0">
                <Icon type="ios-cloud-upload" size="30" style="color: #3399ff"></Icon>
                <p>将图片拖拽到此处上传</p>
              </div>
            </Upload>
          </FormItem>
          <FormItem label="详情照片">
            <div class="img-list">
              <div v-for="(item, index) in formData.DealerStoreImgs"
                v-if="item.ImgType==2"
               :key="index" class="img-cell"
                v-bind:style="{'background-image':'url(' + item.ImgUrl+ ')','background-size': 'cover','background-position': 'center center','background-repeat':'no-repeat','background-color': 'black'}">
                <div class="demo-upload-list-cover">
                  <Icon type="ios-eye-outline" size="30" @click.native="viewimg(item)"></Icon>
                  <Icon type="ios-trash-outline" size="30" @click.native="handleRemove(index)"></Icon>
                </div>
              </div>
            </div>
            <Upload type="drag" :format="['jpg']" :max-size="2048" 
              :with-credentials="true" :show-upload-list="true"
              :on-success="UploadSuccess" :on-error="UploadError" :on-format-error="handleFormatError"
              :on-exceeded-size="handleMaxSize" :before-upload="handleDetailBeforeUpload" :action="StoreDetailImg_uploadUrl"
              style="display: inline-block;min-width:600px;">
              <div style="padding: 20px 0">
                <Icon type="ios-cloud-upload" size="30" style="color: #3399ff"></Icon>
                <p>将图片拖拽到此处上传</p>
              </div>
            </Upload>
          </FormItem>
          <FormItem label="地址">
                <Input v-model="formData.DealerInfo.DealerAddr" style="width:500px" placeholder=""></Input>
                <div style="padding:10px">
                  <div class="map-search-wrap">
                    <Input
                      v-model="mapSearchKeyword"
                      placeholder="搜索地址"
                      @on-change="onMapSearchInput"
                      style="width:100%"
                    />
                    <ul v-show="mapTips.length" class="map-search-tips">
                      <li
                        v-for="(tip, idx) in mapTips"
                        :key="idx"
                        @click="selectMapTip(tip)"
                      >
                        <span class="tip-name">{{ tip.name }}</span>
                        <span class="tip-addr">{{ tip.district || '' }}{{ tip.address || '' }}</span>
                      </li>
                    </ul>
                  </div>
                  <div id="dealer-map" style="width:100%;height:400px;border:1px solid #dcdee2;border-radius:4px"></div>
                  <div style="color:#888;font-size:12px;margin-top:4px">输入地址从下拉中选择，或直接点击地图选点（地址会自动填充）</div>
                </div>
          </FormItem>
        </Col>
    </Row>

      <FormItem>
        <Button @click="SubmitData" type="primary">保存</Button>
        <Button @click="BackList" type="default" style="margin-left: 8px">返回</Button>
      </FormItem>
      <Spin size="large" fix v-if="spinShow"></Spin>

    </Form>
    <Modal v-model="imgviewmodal" width="880px">
      <p slot="header" style="text-align:center;">
        <span>图片预览</span>
      </p>
      <div style="text-align:center;display: flex;align-items: center;">
        <img style="max-width: 760px;max-height: 600px;" :src="currentImgurl" alt="">
      </div>
    </Modal>
  </div>
</template>


<script>
import oss from 'ali-oss';
import AMap from "@/utils/initMap";
export default {

  data() {
    return {
      spinShow: false,
      imgFile:'',
      imgviewmodal: false,
      currentImgurl: "",
      StoreHeadImg_uploadUrl:'',
      StoreDetailImg_uploadUrl:'',
      mapSearchKeyword: '',
      mapTips: [],
      mapSearchTimer: null,
      dealerMap: null,
      AMapNS: null,
      geocoder: null,
      autoComplete: null,
      placeSearch: null,
      currentMarker: null,
      formData: {
        DealerInfo: {
          ID: 0,
          Name: "",
          Tel: "",
          DealerName:"",
          AutoPreCode: "",
          ContactTel: "",
          DealerAddr: "",
          Password: "",
          Broker: "",
          Level: "1",
          ParentId: 0,
          ParentDealerDesc: "",
          CurrentInCreaseNum: 0,
          TotalInCreaseNum: 0,
          WXOpenId: "",
          _CreateBy: 0,
          _CreateTime: "",
          _IsDelete: 0,
          _UpdateBy: 0,
          _UpdateTime: ""
        },
        DealerStore:{
          DealerID:"",
          StoreType:"",
          StoreTag:"a,2,3",
          Lat:"",
          Lgt:"",
          OpenTime:"",
          CloseTime:"",
          StoreTel:"",
          _CreateBy: 0,
          _CreateTime: "",
          _IsDelete: 0,
          _UpdateBy: 0,
          _UpdateTime: ""
        },
        DealerStoreImgs:[],
      }
    };
  },
  methods: {
    BackList: function() {
      this.$router.push({ name: "dealer_childdealerlist" });
    },
    SubmitData: function() {
      var that = this;
      var url = "Dealer/EditDealer";
      this.$http.post(url, that.formData).then(res => {
        var modaltitle = "";
        if (res.data != "success") {
          modaltitle = res.data;
        } else {
          modaltitle = "提交成功！";
        }
        this.$Modal.info({
          title: "提示",
          content: modaltitle
        });
        this.$router.push({ name: "dealer_childdealerlist" });
      });
    },
    GetDealer: function(id) {
      var that = this;
      this.$http
        .get("Dealer/GetDealerWithStrore", { params: { id: id } })
        .then(res => {          
          this.formData = res.data.Data;

          // 如果有已标记的位置，在地图上显示
          that.applyExistingMark();
        })
        .catch(function() {})
        .then(function() {
          that.spinShow = false;
        });
    },

    SetLoc: function (lat, lng, address) {
      if (!this.formData.DealerStore) {
        this.$set(this.formData, 'DealerStore', {
          DealerID: "",
          StoreType: "",
          StoreTag: "",
          Lat: "",
          Lgt: "",
          OpenTime: "",
          CloseTime: "",
          StoreTel: "",
        });
      }
      this.formData.DealerStore.Lat = lat;
      this.formData.DealerStore.Lgt = lng;
      this.formData.DealerInfo.DealerAddr = address;
    },

    onMapSearchInput: function(val) {
      var that = this;
      if (this.mapSearchTimer) {
        clearTimeout(this.mapSearchTimer);
      }
      var keyword = (typeof val === 'string' ? val : (this.mapSearchKeyword || '')).trim();
      this.mapSearchKeyword = keyword;
      if (!keyword || !this.autoComplete) {
        this.mapTips = [];
        return;
      }
      this.mapSearchTimer = setTimeout(function() {
        that.autoComplete.search(keyword, function(status, result) {
          if (status === 'complete' && result.tips) {
            that.mapTips = result.tips.filter(function(tip) {
              return tip.name;
            });
          } else {
            that.mapTips = [];
          }
        });
      }, 300);
    },

    selectMapTip: function(tip) {
      var that = this;
      this.mapTips = [];
      this.mapSearchKeyword = tip.name;
      var address = (tip.district || '') + (tip.address || tip.name || '');

      var lng = null;
      var lat = null;
      if (tip.location) {
        if (typeof tip.location.getLng === 'function') {
          lng = tip.location.getLng();
          lat = tip.location.getLat();
        } else if (tip.location.lng && tip.location.lat) {
          lng = tip.location.lng;
          lat = tip.location.lat;
        }
      }

      if (lng != null && lat != null) {
        this.dealerMap.setZoomAndCenter(16, [lng, lat], true);
        this.setLocationMarker(lat, lng, address || tip.name);
        return;
      }

      if (!this.placeSearch) {
        this.$Message.info("未找到相关地址坐标");
        return;
      }
      this.placeSearch.search(tip.name, function(status, result) {
        if (status === 'complete' && result.poiList && result.poiList.pois.length > 0) {
          var poi = result.poiList.pois[0];
          that.dealerMap.setZoomAndCenter(16, [poi.location.lng, poi.location.lat], true);
          that.setLocationMarker(
            poi.location.lat,
            poi.location.lng,
            poi.address || poi.name
          );
        } else {
          that.$Message.info("未找到相关地址坐标");
        }
      });
    },

    applyExistingMark: function() {
      if (!this.dealerMap || !this.AMapNS) return;
      if (!this.formData.DealerStore || !this.formData.DealerStore.Lat || !this.formData.DealerStore.Lgt) return;
      var lat = parseFloat(this.formData.DealerStore.Lat);
      var lng = parseFloat(this.formData.DealerStore.Lgt);
      if (isNaN(lat) || isNaN(lng)) return;
      this.setLocationMarker(lat, lng, this.formData.DealerInfo.DealerAddr || '');
      this.dealerMap.setZoomAndCenter(16, [lng, lat], true);
    },

    // 设置位置标记
    setLocationMarker: function(lat, lng, address) {
      var AMap = this.AMapNS;
      if (!AMap || !this.dealerMap) return;
      if (this.currentMarker) {
        this.dealerMap.remove(this.currentMarker);
      }
      this.currentMarker = new AMap.Marker({
        position: new AMap.LngLat(lng, lat),
        title: address,
      });
      this.dealerMap.add(this.currentMarker);
      this.SetLoc(lat, lng, address);
    },

    reverseGeocode: function(lng, lat) {
      var that = this;
      var doGeocode = function() {
        that.geocoder.getAddress([lng, lat], function(status, result) {
          var address = '';
          if (status === 'complete' && result && result.regeocode) {
            address =
              result.regeocode.formattedAddress ||
              result.regeocode.formatted_address ||
              '';
          }
          that.setLocationMarker(lat, lng, address);
        });
      };
      if (this.geocoder) {
        doGeocode();
        return;
      }
      if (!this.AMapNS) return;
      this.AMapNS.plugin('AMap.Geocoder', function() {
        that.geocoder = new that.AMapNS.Geocoder({ city: '长沙' });
        doGeocode();
      });
    },

    initDealerMapPlugins: function(AMap) {
      var that = this;
      AMap.plugin('AMap.Geocoder', function() {
        that.geocoder = new AMap.Geocoder({ city: '长沙' });
      });
      AMap.plugin('AMap.AutoComplete', function() {
        that.autoComplete = new AMap.AutoComplete({
          city: '长沙',
          citylimit: false,
        });
      });
      AMap.plugin('AMap.PlaceSearch', function() {
        that.placeSearch = new AMap.PlaceSearch({
          city: '长沙',
          pageSize: 10,
          pageIndex: 1,
        });
      });
    },

    //#region tag相关
    splitedList:function (str) {      
      if(str==null||str=='')  {
        return [];
      }
        return str.split(',');
    },
    addTag:function(value){
      var tag=","+value;
      if(this.formData.DealerStore.StoreTag==''){

        this.formData.DealerStore.StoreTag += value;
      }else{
        this.formData.DealerStore.StoreTag += tag;
      }
    },
    removeTag:function(event, name){      
      var oldArr= this.splitedList(this.formData.DealerStore.StoreTag);      
      oldArr.splice(name,1);
      this.formData.DealerStore.StoreTag = oldArr.join();      
    },
//#endregion

    //#region 图片相关方法    
    viewimg(item, type) {
      this.imgviewmodal = true;
      this.currentImgurl = item.ImgUrl;
    },
    handleRemove(idx) {
      var that = this;
      this.formData.DealerStoreImgs.splice(idx,1)      
    },
    handledetRemove(item) {
      var that = this;
      that.$http
        .get("Order/DeleteGoodsDetImg", {
          params: { id: that.postdata.ID, filename: item.name }
        })
        .then(res => {
          this.$Message.info("操作成功!");
          that.GetData(that.$route.query.id);
        });
    },
    //#endregion

    //#region 上传相关
    UploadSuccess: function(response, file, fileList) {
      this.$Message.info("上传成功!");
      this.GetDealer(this.$route.query.id);
    },
    UploadError: function(error, file, fileList) {
      this.$Notice.error({
        title: "系统异常"
      });
    },
    handleBeforeUpload(file) {
      console.log('开始');
      if (this.formData.DealerStore.ID == undefined) {
        this.$Notice.warning({
          title: "提示",
          desc: "请先保存门店基础信息后上传图片！"
        });
        return false;
      }
      this.file = file;
      this.upload(1);
      return false
    },
    handleDetailBeforeUpload(file) {
      console.log('开始');
      if (this.formData.DealerStore.ID == undefined) {
        this.$Notice.warning({
          title: "提示",
          desc: "请先保存门店基础信息后上传图片！"
        });
        return false;
      }
      this.file = file;
      this.upload(2);
      return false
    },

     // 点击上传按钮触发上传操作
    upload(type){
        console.log('开始手动上传')
        const client = new oss({
            region: 'oss-cn-hangzhou',
            accessKeyId: 'LTAI5tPTBs6Dvfp5Bf4t9oQp',
            accessKeySecret: 'OITcxx2SOT3RoNprm53WuxGoEnDirE',
            bucket: 'reaca-bucket',
        });
        
        const Name = this.file.name;
        const suffix = Name.substr(Name.indexOf('.'));
        const filename = Date.parse(new Date()) + suffix
        var path ='DealerStoreImg/'+this.formData.DealerInfo.ID+"/"+filename;

        client.multipartUpload(path, this.file).then(res => {
            console.log('上传成功：',res);
            this.formData.DealerStoreImgs.push({
              ImgType:type,
              ImgUrl:this.$file.url+path,
              StoreID:0
            })            
        }).catch(err => {
            this.$Notice.warning({
              title: "上传失败",
              desc: "请联系系统管理员"
            });
        })
    },
    handleFormatError(file) {
      this.$Notice.warning({
        title: "文件格式错误",
        desc: "文件 " + file.name + " 格式错误,请选择jpg格式"
      });
    },
    handleMaxSize(file) {
      this.$Notice.warning({
        title: "文件超出大小",
        desc: "文件: " + file.name + " 不能超过2M"
      });
    }
    //#endregion
  },
  watch: {},
  created: function() {
    var that = this;
    this.spinShow = true;
  },
  mounted: function() {
    var that = this;
    this.GetDealer(this.$route.query.id);

    AMap.init().then((AMap) => {
      if (that._isDestroyed || that._isBeingDestroyed) return;
      that.AMapNS = AMap;
      that.dealerMap = new AMap.Map("dealer-map", {
        center: [112.977361, 28.19652],
        zoom: 12,
        viewMode: "2D",
      });

      that.dealerMap.on("click", function(e) {
        var lng = e.lnglat.getLng ? e.lnglat.getLng() : e.lnglat.lng;
        var lat = e.lnglat.getLat ? e.lnglat.getLat() : e.lnglat.lat;
        that.mapTips = [];
        that.setLocationMarker(lat, lng, '');
        that.reverseGeocode(lng, lat);
      });

      that.initDealerMapPlugins(AMap);
      that.applyExistingMark();
    });
  },
  beforeDestroy: function() {
    if (this.mapSearchTimer) {
      clearTimeout(this.mapSearchTimer);
      this.mapSearchTimer = null;
    }
    if (this.dealerMap) {
      this.dealerMap.destroy();
      this.dealerMap = null;
    }
    this.currentMarker = null;
    this.geocoder = null;
    this.autoComplete = null;
    this.placeSearch = null;
    this.AMapNS = null;
  }
};
</script>

<style>
.map-search-wrap {
  position: relative;
  margin-bottom: 8px;
}
.map-search-tips {
  position: absolute;
  left: 0;
  right: 0;
  top: 100%;
  z-index: 20;
  margin: 0;
  padding: 0;
  list-style: none;
  max-height: 240px;
  overflow-y: auto;
  background: #fff;
  border: 1px solid #dcdee2;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
}
.map-search-tips li {
  padding: 8px 12px;
  cursor: pointer;
  line-height: 1.4;
}
.map-search-tips li:hover {
  background: #f3f3f3;
}
.map-search-tips .tip-name {
  display: block;
  color: #333;
}
.map-search-tips .tip-addr {
  display: block;
  color: #999;
  font-size: 12px;
}
.demo-upload-list-cover {
  display: none;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.6);
}
.img-cell:hover .demo-upload-list-cover {
  display: block;
}
.demo-upload-list-cover i {
  color: #fff;
  font-size: 20px;
  cursor: pointer;
  margin: 0 2px;
}
</style>
